class FormulaWorks extends HTMLElement {
  connectedCallback() {
    const layers = this.querySelectorAll('[data-formula-works-layer-index]');
    const cards = this.querySelectorAll('.formula-works__card');
    if (layers.length === 0 || cards.length === 0) return;

    let currentIndex = 0;
    const ratios = [];
    for (let r = 0; r < cards.length; r++) {
      ratios[r] = 0;
    }

    function getMostVisibleIndex() {
      let maxRatio = 0;
      for (let i = 0; i < ratios.length; i++) {
        if (ratios[i] > maxRatio) maxRatio = ratios[i];
      }
      if (maxRatio <= 0) return 0;
      const threshold = 0.15;
      for (let j = 0; j < ratios.length; j++) {
        if (ratios[j] >= maxRatio - threshold) return j;
      }
      return 0;
    }

    function showLayer(index) {
      if (index === currentIndex) return;
      currentIndex = index;
      for (let i = 0; i < layers.length; i++) {
        if (parseInt(layers[i].getAttribute('data-formula-works-layer-index'), 10) === index) {
          layers[i].classList.add('is-visible');
        } else {
          layers[i].classList.remove('is-visible');
        }
      }
    }

    this._observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          const index = Array.prototype.indexOf.call(cards, entry.target);
          if (index < 0) return;
          ratios[index] = entry.isIntersecting ? entry.intersectionRatio : 0;
        });
        showLayer(getMostVisibleIndex());
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
      }
    );

    for (let i = 0; i < cards.length; i++) {
      this._observer.observe(cards[i]);
    }
  }

  disconnectedCallback() {
    if (this._observer) this._observer.disconnect();
  }
}

customElements.define('formula-works', FormulaWorks);
